import { InitializerExecutor } from '@wajeez-web/core/types';
import { NavigationActions } from '@wajeez-web/stores/common';
import { AiOutlineInteraction } from 'react-icons/ai';

import { EventKeyMappings } from './pages';

export const initializeEventsRoutes: InitializerExecutor = async (dispatch) => {
  dispatch(
    NavigationActions.updateRoutes([
      {
        name: 'Events',
        href: '/events',
        per: ['143.0'],
        icon: AiOutlineInteraction,
      },
    ])
  );
};

export const initializeEventsEndpoints: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateEndpoints([
      {
        type: 'container',
        endpoint: 'events',
        per: ['143.0'],
        crump: 'Events',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: EventKeyMappings,
            per: [],
          },
        ],
      },
    ])
  );
};
